import { endSession } from '@rsos/reduxDataStore/src/features/endSession';
import { refreshUserToken } from '@rsos/sinatra/src/actions/refreshUserToken';
import { createAccessTokenProvider } from '@rsos/sinatra/src/utils/createAccessTokenProvider';
import { store } from '../store';

/**
 * The app's single access-token entry point. The Hermes clients resolve a token
 * through this before every connection attempt and the Ask Harmony panel uses it
 * as its authHandler, so no consumer holds token state or has to be told when a
 * token rotates.
 *
 * `store` is dereferenced inside the callbacks rather than at module load, so
 * this stays safe to import from anywhere in the component tree.
 */
export const getAccessToken = createAccessTokenProvider(
  refreshToken => store.dispatch(refreshUserToken(refreshToken)),
  {
    // Shares its latch with the RTK Query reauth path, so an expiry that
    // reaches both at once still produces one notice and one logout.
    endSession: () => {
      void endSession(store.dispatch);
    },
  },
);

export default getAccessToken;
